{
  "actions": "Дії",
  "hideButtonLabel": "Показувати менше",
  "noTags": "Немає",
  "showAllButtonLabel": "Показати всі ({tagCount, number})"
}
